import { createAction, props } from '@ngrx/store';

import { CowListItem, ProductionSummary } from '../../models/production.model';

export const loadCowListRequest = createAction(
  '[Production] Load cow list',
  props<{ date: string }>(),
);

export const loadCowListSuccess = createAction(
  '[Production] Load cow list succeeded',
  props<{ cowList: CowListItem[] }>(),
);

export const loadProductionSummaryRequest = createAction(
  '[Production] Load production summary data',
  props<{ date: string }>(),
);

export const loadProductionSummarySuccess = createAction(
  '[Production] Load production summary data succeeded',
  props<{ productionSummary: ProductionSummary }>(),
);
